import { z } from 'zod';

import { WorkspaceBundle } from '@adminhub/graphql-types';

import { EnterpriseCollectionPackageType } from './collection-config-types';
import { checkMapKeyMatches } from './common';

const productId = z
  .string()
  .describe(
    'The productId for the product. This is used to map the product to its details and offerings in CCP. Each product must be available at https://workbench.staging.atl-paas.net/products/<productId>',
  );

const CollectionConfigJsonSchema = z.object({
  productId,
  type: z.nativeEnum(WorkspaceBundle).describe('The Workspace Bundle type.'),
  enterpriseCollectionPackageType: z
    .nativeEnum(EnterpriseCollectionPackageType)
    .optional()
    .describe('The package type associated with an enterprise collections bundle'),
  offersEnterpriseAppsDeterminant: z
    .union([z.boolean(), z.string()])
    .optional()
    .describe('Boolean or gate name to determine if the collection offers enterprise child apps.'),
  childProductIds: z.array(z.string()).optional().describe('List of child product IDs included in the collection.'),
});

export type CollectionConfigJson = z.infer<typeof CollectionConfigJsonSchema>;

const checkCollectionConfigKeysMatch = (data: Record<string, CollectionConfigJson>, ctx: z.RefinementCtx) =>
  checkMapKeyMatches(data, 'productId', ctx);

export const CollectionConfigMapJsonSchema = z.object({
  $schema: z.string().optional(),
  collections: z.record(productId, CollectionConfigJsonSchema).superRefine(checkCollectionConfigKeysMatch),
});

export type CollectionConfigMapJson = z.infer<typeof CollectionConfigMapJsonSchema>;
